import React from 'react';
import styled from 'styled-components';

const FormattedTextDiv = styled.div`
  white-space: pre-line;
`;

export interface CustomAccountInvoiceNotesProps {
  notes: string[];
}

export const CustomAccountInvoiceNotes: React.FC<CustomAccountInvoiceNotesProps> = ({notes}) => {
  const text = notes.join('\n');
  return <FormattedTextDiv>{text}</FormattedTextDiv>;
};
